// Core
import React, { useEffect, useState } from "react";

import "./styles.scss";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  getAgeOfBacklogsRequest_ADMIN,
  getAssessmentsSubmittedByCompaniesRequest_ADMIN,
  getDashboardBacklogCountsRequest_ADMIN,
  getRecommendationsSubmittedByAssessorsRequest_ADMIN,
  getRecentAssessmentRequest_ADMIN,
  getRecentSubmissionRequest_ADMIN,
} from "../../../../Redux/Slices/Admin/adminSlice";

// Custom layout
import MainLayout from "Layouts/Main";

// import Dropdown from "Components/Dropdown";
import DetailsCard from "Components/DetailsCard";
import LineChart from "Components/Charts";
import CustomSelect from "Components/CustomSelect";

import completedRequestsIcon from "../../../../Assets/Images/completedRequestIcons.png";
import inProgressRequestIcon from "../../../../Assets/Images/inProgressRequestsIcon.png";
import newRequestIcon from "../../../../Assets/Images/newRequestIcon.png";
import profilePictureSampleImage from "../../../../Assets/Images/avator.png";
import companyImgae from "../../../../Assets/Svg/Auth/CompanyImageAdmin.svg";
import BarChartComponent from "Components/BarChart";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const Dashboard = () => {
  //Initialize redux
  const dispatch = useDispatch();

  const [selectedOption, setSelectedOption] = useState("weekly"); // Initial value can be empty or a default value
  const [numberOfBacklogs, setNumberOfBacklogs] = useState("");
  const [inProgressBacklogs, setInProgressBacklogs] = useState("");
  const [completedBacklogs, setCompletedBacklogs] = useState("");
  const [ageOfBacklogs, setAgeOfBacklogs] = useState({});
  const [recentAssessment, setRecentAssessment] = useState([]);
  const [recentSubmission, setRecentSubmission] = useState([]);
  const [assessmentsSubmittedByCompanies, setAssessmentsSubmittedByCompanies] =
    useState({});
  const [
    recommendationsSubmittedByAssessor,
    setRecommendationsSubmittedByAssessor,
  ] = useState({});
  const isLoading = useSelector((state) => state.admin.isLoading);

  // const handleDropdownChange = (e) => {
  //   setSelectedOption(e.target.value);
  // };

  const filterOptions = [
    { label: "Last Week", value: "weekly" },
    { label: "Last Six Month", value: "lastsixmonth" },
    { label: "Last Year", value: "lastyear" },
  ];

  const filterStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #464646",
      borderRadius: "6px",
      padding: "4px",
      width: "237px",
      minHeight: "44px",
      height: "42px",
      cursor: "pointer",
      boxShadow: "4px 4px 8px rgba(0, 0, 0, 0.1)",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#1F2155"
        : state.isFocused
        ? "#e9ecef"
        : "#fff",
      color: state.isSelected ? "#fff" : "#000",
      padding: 10,
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#1F2155"
          : state.isFocused
          ? "#e9ecef"
          : "#fff",
        color: state.isSelected ? "#fff" : "#000",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#000000",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#121212",
      padding: "0 8px",
    }),
  };

  useEffect(() => {
    baseApiCalls();
  }, [selectedOption]);

  const baseApiCalls = async () => {
    // To get the top 3 count of dashboard
    await dispatch(
      getDashboardBacklogCountsRequest_ADMIN({
        period: selectedOption,
        callBack: getDashboardBacklogCountsRequestCB_ADMIN,
      })
    );

    // To get age of backlogs
    await dispatch(
      getAgeOfBacklogsRequest_ADMIN({
        callBack: getAgeOfBacklogsRequestCB_ADMIN,
      })
    );

    // To get asssessments submitted by companies request
    await dispatch(
      getAssessmentsSubmittedByCompaniesRequest_ADMIN({
        period: selectedOption,
        callBack: getAssessmentsSubmittedByCompaniesRequestCB_ADMIN,
      })
    );

    // To get recommendations submitted by assessors request
    await dispatch(
      getRecommendationsSubmittedByAssessorsRequest_ADMIN({
        period: selectedOption,
        callBack: getRecommendationsSubmittedByAssessorsRequestCB_ADMIN,
      })
    );

    // To get recent assessment request
    await dispatch(
      getRecentAssessmentRequest_ADMIN({
        callBack: getRecentAssessmentRequestCB_ADMIN,
      })
    );

    // to get recent submission request
    await dispatch(
      getRecentSubmissionRequest_ADMIN({
        callBack: getRecentSubmissionRequestCB_ADMIN,
      })
    );
  };

  //To handle the response of getDashboardBacklogCountsRequest_ADMIN
  const getDashboardBacklogCountsRequestCB_ADMIN = (data) => {
    setNumberOfBacklogs(data?.totalBacklogs);
    setInProgressBacklogs(data?.inProgressBacklogs);
    setCompletedBacklogs(data?.completedBacklogs);
  };

  //To handle the response of getAgeOfBacklogsRequest_ADMIN
  const getAgeOfBacklogsRequestCB_ADMIN = (data) => {
    setAgeOfBacklogs(data);
  };

  //To handle the response of getAssessmentsSubmittedByCompaniesRequest_ADMIN
  const getAssessmentsSubmittedByCompaniesRequestCB_ADMIN = (data) => {
    setAssessmentsSubmittedByCompanies(data);
  };

  //To handle the response of getRecommendationsSubmittedByAssessorsRequest_ADMIN
  const getRecommendationsSubmittedByAssessorsRequestCB_ADMIN = (data) => {
    setRecommendationsSubmittedByAssessor(data);
  };

  const getRecentAssessmentRequestCB_ADMIN = (data) => {
    setRecentAssessment(data);
  };

  const getRecentSubmissionRequestCB_ADMIN = (data) => {
    setRecentSubmission(data);
  };

  return (
    <MainLayout>
      <div className="dashboardContainer">
        <div className="dashboardHeader">
          <h1>Dashboard</h1>

          <CustomSelect
            defaultValue={filterOptions?.[0]}
            options={filterOptions}
            customStyles={filterStyles}
            placeholder="Select Filter"
            onChange={(data) => {
              setSelectedOption(data?.value);
            }}
          />

          {/* <Dropdown
            options={[
              { label: "This Week", value: "thisweek" },
              { label: "Last Week", value: "weekly" },
              { label: "Last Month", value: "lastmonth" },
              { label: "Last Six Month", value: "lastsixmonth" },
              { label: "Last Year", value: "lastyear" },
            ]}
            value={selectedOption}
            onChange={handleDropdownChange}
            dropdownStyle={{
              width: "250px",
              Height:"50px",
              marginRight: "10px",
              padding: "10px",
            }}
          /> */}
        </div>
        {isLoading === 'loading' ? (
          <div style={{ display: "flex", gap: "10px", justifyContent: "space-between" }}>
            <Skeleton height={120} width={300} style={{ margin: "0 10px" }} />
            <Skeleton height={120} width={300} style={{ margin: "0 10px" }} />
            <Skeleton height={120} width={300} style={{ margin: "0 10px" }} />
          </div>
            ) : (
        <div className="cardContainer">
            <>
              <DetailsCard
            image={newRequestIcon}
            info={numberOfBacklogs}
            title="Total Number of Assessment"
            // title="Total Number of Backlogs"
            backgroundColor="#DAECFF"
            color="#3093FB"
          />
          <DetailsCard
            image={inProgressRequestIcon}
            info={inProgressBacklogs}
            title="In-Progress Assessment"
            // title="In-Progress Assessment Backlog"
            backgroundColor="#FFD3D0"
            color="#CB4A01"
          />
          <DetailsCard
            image={completedRequestsIcon}
            info={completedBacklogs}
            title="Completed Assessment"
            // title="Completed Assessment Backlog"
            backgroundColor="#B6F3F4"
            color="#51C9C9"
            />
            </>
        </div>)}
        <p className="barCartComponentHeader">Age of Backlogs</p>
        <div className="barCartComponent">
          <BarChartComponent chartData={ageOfBacklogs} />
        </div>
        <div className="chartContainer">
          <div className="chart">
            <p>Pre - Assessments Submitted by Companies</p>
            <LineChart
              chartData={assessmentsSubmittedByCompanies}
              width={"40%"}
            />
          </div>
          <div className="chart">
            <p>Assessments Submitted by Assessors</p>
            <LineChart
              width={"40%"}
              chartData={recommendationsSubmittedByAssessor}
              borderColor="#5AC7FA" // Line color
              pointBackgroundColor="#12214F" // Color of the point circles
              pointBorderColor="#5AC7FA" // Border color of the point circles
            />
          </div>
        </div>
        <div className="bottomContainer">
          <div className="requestCards">
            <p className="requestCardsHeading">
              Recent Submission from Companies
            </p>
            <div className="request-column">
              {recentSubmission?.map((accessor) => (
                <div className="requestCard">
                  <div className="requestProfileImg">
                    <img src={companyImgae} alt="companyProfilePic" />
                    <div className="requestDetails">
                      <p style={{ color: "#232323" }}>
                        {accessor.company_name}
                      </p>
                      <p>{accessor.last_updated_time}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="accessorCards">
            <p className="accessorCardHeading">
              Recent Assessments from Assessors
            </p>
            <div className="accessor-column">
              {recentAssessment?.map((accessor) => (
                <div className="AccessorCard">
                  <div className="accDetailContainer">
                    <img
                      src={accessor.profile_image || profilePictureSampleImage}
                      className="profile"
                      alt="Img"
                    />
                    <div className="accDetailContainerInner">
                      <p>{accessor?.assessor_name}</p>
                      <p style={{ color: "#718EBF", fontSize: "13px" }}>
                        {accessor?.company_name}
                      </p>
                    </div>
                  </div>
                  <div className="accCompanyVisitContainer">
                    <p
                      style={{
                        color:
                          accessor?.status === 3
                            ? "#16DBAA"
                            : accessor?.status === 2
                            ? "#FFA500"
                            : "#FE5C73",
                        width: "120px",
                        textAlign: "right",
                      }}
                    >
                      {accessor?.status === 1
                        ? "Pending"
                        : accessor?.status === 2
                        ? "In Progress"
                        : "Completed"}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Dashboard;
